import { TblCol, TblFltOption } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';
import FormattedDateRenderer from '../../../../core/table/renderers/FormattedDateRenderer';
import { createSubscribeToggleRenderer } from './SubscribeToggleRenderer';

export type MonitorStatusColKey =
    | ''
    | 'Status'
    | 'CE'
    | 'RXVEN'
    | 'MonitorType'
    | 'Changed'
    | 'LastChecked'
    | 'SubscribedEmail'
    | 'SubscribedInApp';

function statusFilterOptions(isVerity = false): TblFltOption[] {
    const opts: TblFltOption[] = [
        { lbl: 'ALL', val: '' },
        { lbl: 'FAIL', val: 'FAIL' },
        { lbl: 'PASS', val: 'PASS' },
    ];
    // VERITY datafeed rows can also be OFF (monitor disabled)
    if (isVerity) opts.push({ lbl: 'OFF', val: 'OFF' });
    return opts;
}

export function monitorStatusColumnSpec(
    monitorTypes: string[],
    onSubscribeToggle?: (item: any, colKey: string, newVal: boolean) => Promise<boolean>,
    isVerity = false,
): Map<MonitorStatusColKey, TblCol> {
    const map = new Map<MonitorStatusColKey, TblCol>();
    const subscribeRenderer = onSubscribeToggle ? createSubscribeToggleRenderer(onSubscribeToggle) : undefined;
    tblSpecAddColumn<MonitorStatusColKey>(map, 'Status', {
        width: '100px',
        title: 'Status',
        type: 'DROPTEXT',
        fltOptions: statusFilterOptions(isVerity),
    });
    tblSpecAddColumn<MonitorStatusColKey>(map, 'CE', { title: 'Facility' });
    tblSpecAddColumn<MonitorStatusColKey>(map, 'RXVEN', { title: 'Pharmacy / Vendor' });
    tblSpecAddColumn<MonitorStatusColKey>(map, 'MonitorType', {
        title: 'Monitor Type',
        type: 'MULTISELECT',
        width: '320px',
        fltOptions: monitorTypes.map(t => ({ lbl: t, val: t })),
    });
    tblSpecAddColumn<MonitorStatusColKey>(map, 'Changed', { title: 'Changed', type: 'DATE' }, FormattedDateRenderer);
    tblSpecAddColumn<MonitorStatusColKey>(
        map,
        'LastChecked',
        { title: 'Last Activity', type: 'DATE' },
        FormattedDateRenderer,
    );
    tblSpecAddColumn<MonitorStatusColKey>(map, 'SubscribedEmail', { title: 'Email', width: '80px' }, subscribeRenderer);
    tblSpecAddColumn<MonitorStatusColKey>(
        map,
        'SubscribedInApp',
        { title: 'In Application', width: '120px' },
        subscribeRenderer,
    );
    return map;
}

export function monitorStatusDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Status',
                cols: ['Status'],
            },
            {
                title: 'Entity',
                cols: ['CE', 'RXVEN'],
            },
            {
                title: 'Monitor Type',
                cols: ['MonitorType'],
            },
            {
                title: 'Dates',
                cols: ['Changed', 'LastChecked'],
            },
            {
                title: 'Alerts',
                cols: ['SubscribedEmail', 'SubscribedInApp'],
            },
        ],
        sortby: '-Changed',
    };
}
